import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Terms() {
    const { t } = useTranslation();
    return (
        <main className="min-h-[calc(100vh-73px)] max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
            <Link to="/" className="text-xs uppercase tracking-[0.3em] text-[var(--ink-muted)] hover:text-[var(--accent)] transition-colors mb-6 inline-block">
                ← {t("nav.home", "Home")}
            </Link>
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent)] mb-3">{t("terms.eyebrow")}</p>
            <h1
                className="font-display text-5xl md:text-6xl text-[var(--ink)] tracking-tight mb-4"
                style={{ fontVariationSettings: '"wght" 700, "wdth" 80, "opsz" 144' }}
            >
                {t("terms.title")}
            </h1>
            <p className="text-[var(--ink-muted)] text-lg mb-12">{t("terms.lead")}</p>

            {[
                "buyer_protection",
                "escrow",
                "delivery",
                "commission",
                "disputes",
                "prohibited",
                "data",
                "modifications",
            ].map((key) => (
                <section key={key} className="mb-12">
                    <h2
                        className="font-display text-2xl md:text-3xl text-[var(--ink)] mb-3"
                        style={{ fontVariationSettings: '"wght" 600, "wdth" 88, "opsz" 48' }}
                    >
                        {t(`terms.${key}_title`)}
                    </h2>
                    <p className="text-[var(--ink-muted)] leading-relaxed whitespace-pre-line">
                        {t(`terms.${key}_body`)}
                    </p>
                </section>
            ))}

            <p className="text-xs text-[var(--ink-dim)] italic mt-16 border-t border-[var(--border)] pt-8">
                {t("terms.last_updated")}
            </p>
        </main>
    );
}
